module.exports = __webpack_public_path__ + "static/media/j.504ef359.svg";